import { defineMessages } from 'react-intl';

export default defineMessages({
  tab01: { id: 'gofre.Subscriptions.faqs.tabs.tab1' },
  tab02: { id: 'gofre.Subscriptions.faqs.tabs.tab2' },
});
